import { values } from "lodash";

export const laptopOptions = [
  { label: 'MacBook', value: 'MacBook' },
  { label: 'Windows', value: 'Windows' }
];

export const assetTypeOptions = [
  { label: 'Headset', value: 'Headset' },
  { label: 'Connector', value: 'Connector' },
  { label: 'Mouse', value: 'Mouse'},
  { label: 'Monitor', value: 'Monitor' },
  { label: 'Webcam', value: 'Webcam' },
  {label: 'Charger',value: 'Charger'}
];

export const historyFields = [
  { label: 'Laptop', value: 'laptopType' },
  { label: 'Laptop Serial Number', value: 'laptopSerialNumber' },
  { label: 'Charger Serial Number', value: 'chargerSerialNumber' },
  { label: 'Accessories Type', value: 'accessoriesType' }
];